import { stringify } from '@angular/compiler/src/util';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FileUpload } from '../model/file-upload';
import { FirebaseService } from '../services/firebase.service';
import { UploadFileService } from '../services/upload-file.service';

@Component({
  selector: 'app-dash-admin',
  templateUrl: './dash-admin.component.html',
  styleUrls: ['./dash-admin.component.css']
})
export class DashAdminComponent implements OnInit {
  userid!:string;
  profileurl!:string;
  obj : any;
  data_target: any;
  username!:string;
  agent_details_appraval_req_main : any[] = [];
  array_size:any;
  card_details_appraval_req_main : any[] = [];
  card_array_size:any;
  employee_details_main : any[] = [];

  gen_ref_code !: string;
  gen_ref_code_name !: string;
  gen_ref_code_phone !: string;
  gen_ref_code_aadhar !: string;

  admin_user : string;
//   selectedEmpProfFiles: FileList;
//   currentFileEmpProfUpload: FileUpload;
//   percentageEmpProf: number;


// selectEmpProfFile(event) {
//   this.selectedEmpProfFiles = event.target.files;
// }

// upload() {
//   const file = this.selectedEmpProfFiles.item(0);
//   this.selectedEmpProfFiles = undefined;
//   this.currentFileEmpProfUpload = new FileUpload(file);
//   this.uploadService.pushEmployeeProfilePicFileToStorage(this.currentFileEmpProfUpload).subscribe(
//     percentage => {
//       this.percentageEmpProf = Math.round(percentage);
//     },
//     error => {
//       console.log(error);
//     }
//   );
// }

  constructor(private router: Router, public firebaseService: FirebaseService,private firestore: AngularFirestore,private uploadService: UploadFileService) {
    this.obj = JSON.parse(localStorage.getItem('user')|| '{}');
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
  };
    this.firestore.collection("users").ref.where("username", "==", this.obj.email).onSnapshot(snap =>{
      snap.forEach(userRef => {
        if(userRef.data()["role"] !== "admin"){

          var elements= document.getElementById('admin');
          elements.className = " display_none";
        }else{
        this.firestore.collection("users").ref.doc(this.obj.email)
        .get()
        .then((querySnapshot) => {
                this.profileurl = querySnapshot.data()['profileurl'];
                this.username = querySnapshot.data()["name"];
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });
        // agent requested details
        this.firestore.collection("for-business").ref.where("approvalstage", "==", "Requested").get()
        .then((querySnapshot) => {
          this.array_size = querySnapshot.size;
          querySnapshot.forEach((doc) => {
            this.agent_details_appraval_req_main.push([doc.data()["name"],
            doc.data()["email"],
            doc.data()["phoneno"],
            doc.data()["alternativeno"],
            doc.data()["aadharno"],
            doc.data()["address"],
            doc.data()["approvalstage"]]);
           });
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });

        // card requested details
        this.firestore.collection("users").ref.where("approval_status", "==", "Requested").get()
        .then((querySnapshot) => {
          this.card_array_size = querySnapshot.size;
          querySnapshot.forEach((doc) => {
            this.card_details_appraval_req_main.push([doc.data()["name"],
            doc.data()["username"],
            doc.data()["phoneno"],
            doc.data()["reference_code"],
            doc.data()["package"],
            doc.data()["createddate"].toDate(),
            doc.data()["enddate"].toDate(),
            doc.data()["approval_status"]]);
           });
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });

        // Employee details
        this.firestore.collection("employees").ref.get()
        .then((querySnapshot) => {
          this.card_array_size = querySnapshot.size;
          querySnapshot.forEach((doc) => {
            this.employee_details_main.push([doc.data()["firstname"],
            doc.data()["middlename"],
            doc.data()["lastname"],
            doc.data()["posdesig"],
            doc.data()["address"],
            doc.data()["phone"],
            doc.data()["aphone"],
            doc.data()["landline"],
            doc.data()["email"],
            doc.data()["whatsapp"]
            ]);
           });
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });
      }
      })
    })

  }
  ngOnInit(): void {
  }




  // basic details
  public employeedetForm = new FormGroup({
    fname: new FormControl('',Validators.maxLength(50)),
    mname: new FormControl('',Validators.maxLength(50)),
    lname: new FormControl('',Validators.maxLength(50)),
    pord: new FormControl('',Validators.maxLength(50)),
    cname: new FormControl('',Validators.maxLength(50)),
    nbus: new FormControl('',Validators.maxLength(50)),
    address: new FormControl('',Validators.maxLength(200)),
    ph: new FormControl('',Validators.maxLength(50)),
    aph: new FormControl('',Validators.maxLength(50)),
    ll: new FormControl('',Validators.maxLength(50)),
    em: new FormControl('',Validators.maxLength(50)),
    wa: new FormControl('',Validators.maxLength(50))

  });
  employee_det(formData: FormData){
    let update_details={
      firstname: formData["fname"],
      middlename: formData["mname"],
      lastname: formData["lname"],
      posdesig: formData["pord"],
      address: formData["address"],
      phone: formData["ph"],
      aphone: formData["aph"],
      landline: formData["ll"],
      email: formData["em"],
      whatsapp: formData["wa"]

    }
    this.firebaseService.employeeSignUp(formData["fname"]+formData["mname"]+formData["lname"],formData["em"],formData["ph"].toString());

    this.firestore.collection("employees").doc(formData["em"]).set(update_details)
    .then(user => {
      var elements= document.getElementById('emp-succ');
    elements.className = " saved-ref";
    window.alert("Employee Created Successfully...")
    this.router.navigate(["/admin"]);

     }).catch(err => {
      console.log(err);
    })
  }

  mob_ad_click(){
    var elements= document.getElementById('admin');
    elements.className = " mobile-nav-active2";
    let btn = document.getElementById("mobi");
    if(btn.className === "bi bi-x mobile-nav-toggle2 d-xl-none"){
    btn.className = "bi bi-list mobile-nav-toggle2 d-xl-none";
    elements.className = "";
    }else{
    btn.className = "bi bi-x mobile-nav-toggle2 d-xl-none";
    }
  }
  get_employee_removed(id:string){

        this.firestore.collection("employees").doc(id).delete()
    .then(user => {

     }).catch(err => {
      console.log(err);
    })

    this.firestore.collection("users").doc(id).delete()
    .then(user => {
        window.alert("Employee Removed Successfully...");
     }).catch(err => {
      console.log(err);
    })
  }
  get_approved(id:string){
  this.generate_refrence_code(id);
  let update_details={
    approvalstage: "Approved",
    payment_updated: ""
  }
  this.firestore.collection("for-business").ref.where("email", "==", id).get()
  .then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      this.firestore.collection("for-business").doc(doc.id).update(update_details)
  .then(user => {
    window.alert("Approved...");

   }).catch(err => {
    console.log(err);
  })
     });
  })
  .catch((error) => {
      console.log("Error getting documents: ", error);
  });

  }
  generate_refrence_code(id:string){

    this.firestore.collection("for-business").ref.where("email", "==", id).get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.gen_ref_code_name = doc.data()["name"].toString();
        this.gen_ref_code_phone = doc.data()["phoneno"].toString();
        this.gen_ref_code_aadhar = doc.data()["aadharno"].toString();
        this.gen_ref_code_name = this.gen_ref_code_name.substring(0, 4);
        this.gen_ref_code_phone = this.gen_ref_code_phone.substring(0, 2);
        this.gen_ref_code_aadhar = this.gen_ref_code_aadhar.substring(0, 4);
        this.gen_ref_code = this.gen_ref_code_name+this.gen_ref_code_phone+this.gen_ref_code_aadhar;
        let update_details={
          reference_code: this.gen_ref_code,
        }
        this.firestore.collection("for-business").ref.where("email", "==", id).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.firestore.collection("for-business").doc(doc.id).update(update_details)
        .then(user => {
          this.firebaseService.agentSignUp(this.gen_ref_code_name,id,doc.data()["phoneno"].toString());

         }).catch(err => {
          console.log(err);
        })
           });
        })
        .catch((error) => {
            console.log("Error getting documents: ", error);
        });
       });
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });

  }
  get_rejected(id:string){
    let req_id : any;
  let update_details={
    approvalstage: "Rejected",
  }
  this.firestore.collection("for-business").ref.where("email", "==", id).get()
  .then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      this.firestore.collection("for-business").doc(doc.id).update(update_details)
  .then(user => {

    window.alert("Rejected...");

   }).catch(err => {
    console.log(err);
  })
     });
  })
  .catch((error) => {
      console.log("Error getting documents: ", error);
  });

  }


  // card approval rejection
  get_card_approved(id:string){
    let req_id : any;
    console.log("app"+req_id);
  let update_details={
    approval_status: "Approved",
  }
  this.firestore.collection("users").doc(id).update(update_details)
  .then(user => {
    window.alert("Approved...");
    this.router.navigate(["/admin"]);
  })
  .catch((error) => {
      console.log("Error getting documents: ", error);
  });

  }
  get_card_rejected(id:string){
    let req_id : any;
  let update_details={
    approval_status: "Rejected",
  }
  this.firestore.collection("users").doc(id).update(update_details)
  .then(user => {

    window.alert("Rejected...");
  })
  .catch((error) => {
      console.log("Error getting documents: ", error);
  });

  }

loggedout(){
  this.firebaseService.logOut();
}

}
